import { ContainerElement } from '@/containerElement';

import { YoutubeLogoSVG } from './YouTubeLogoSVG';

export const YouTubePlayButton = () => {
  return (
    <ContainerElement
      element={{
        type: 'container',
        attrs: {
          id: 'play-button-container',
          position: 'absolute',
          top: '0',
          left: '0',
          padding: '0px',
          backgroundColor: 'transparent',
          width_max: '100%',
          height: '100%',
          zIndex: 10,
        },
        content: [],
      }}
    >
      <YoutubeLogoSVG width={64} height={64} />
    </ContainerElement>
  );
};
